module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleE-icon3.9de0d7a5.png";